import React, { useEffect } from 'react';
import checkboxImg from '@/assets/image/checkbox.svg';
import checkboxSelectImg from '@/assets/image/checkbox-select.svg';
import { storagePrefixV2 } from '@/constant';
import {
  setCurrentStep,
  setFormValue,
  setNextBtnConfig,
  setPrevBtnConfig,
  useAIDiagnoseStore,
} from '../../store/useAIDiagnoseStore';
import { ShowTitle } from '../show-title';

import cx from './index.module.scss';

interface Props {}

export const POSTURE_ADJUST_ITEM_2_TEXT: Record<AIDiagnose.PostureAdjustItem, string> = {
  richBag: '富贵包',
  highLowBack: '高低背',
  headTilt: '头前倾',
  roundShoulderBack: '圆肩背',
  camelBack: '驼背',
};

export const POSTURE_ADJUST_ITEM_2_URL: Record<AIDiagnose.PostureAdjustItem, string> = {
  richBag: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/asdfqwf.png',
  highLowBack: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/fghgfj.png',
  headTilt: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/dsfdsfogds.png',
  roundShoulderBack: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/safqwf.png',
  camelBack: storagePrefixV2 + '/ai-consulation/bodyadjust-tips/qwrqgweqg.png',
};

export const PostureCondition: React.FC<Props> = () => {
  const { postureCondition } = useAIDiagnoseStore.use.formValue();

  useEffect(() => {
    setPrevBtnConfig({
      show: true,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev - 1 }));
      },
    });

    setNextBtnConfig({
      disable: !postureCondition?.length,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, [postureCondition?.length]);

  return (
    <div className={cx('PostureCondition')}>
      <ShowTitle title="您希望改善的体态问题" subTitle="可选多个问题" />
      <div className={cx('content')}>
        <div className={cx('condition-wrapper')}>
          {Object.keys(POSTURE_ADJUST_ITEM_2_TEXT).map(item => (
            <div
              className={cx('condition-item', {
                selected: postureCondition?.includes(item as AIDiagnose.PostureAdjustItem),
              })}
              key={item}
              onClick={() =>
                setFormValue({
                  postureCondition: postureCondition?.includes(item as AIDiagnose.PostureAdjustItem)
                    ? postureCondition?.filter(item2 => item2 !== item)
                    : [...(postureCondition || []), item as AIDiagnose.PostureAdjustItem],
                })
              }
            >
              <div className={cx('header')} style={{ backgroundImage: `url(${POSTURE_ADJUST_ITEM_2_URL[item]}` }} />
              <div className={cx('name')}>{POSTURE_ADJUST_ITEM_2_TEXT[item]}</div>
              <img
                src={postureCondition?.includes(item as AIDiagnose.PostureAdjustItem) ? checkboxSelectImg : checkboxImg}
                alt=""
                className={cx('checkbox')}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
